export const CACHE_VERSION = "v3";

export const sportListCacheKey = (sport) =>
  `props:${CACHE_VERSION}:${String(sport || "").toUpperCase()}`;
